<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="title-sign-in">
      <h1>Iniciar sesion</h1>
      <el-button class="btn-facebook">
        Inicar sesión con Facebook
      </el-button>
      <div class="btn-email">
        <span>Iniciar con email</span>
      </div>
    </div>
    <div class="form-sign-in">
      <el-form
        ref="formLogin"
        :model="model"
        :rules="rules"
        @submit.native.prevent="onSubmit">
        <el-form-item prop="email">
          <el-input
            v-model="model.email"
            placeholder="Usuario o email">
            <i
              slot="prefix"
              class="icon-user-icon"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="model.password"
            type="password"
            placeholder="Contraseña">
            <i
              slot="prefix"
              class="icon-key-icon"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="rememberMe">
          <el-checkbox v-model="model.rememberMe">Recordarme en éste equipo</el-checkbox>
        </el-form-item>
        <div class="btns-sign-in">
          <el-button
            class="btn-sign-in"
            type="primary"
            native-type="submit">Iniciar sesión</el-button>
          <el-button
            class="forget-password"
            type="text">Olvidé mi contraseña
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import AuthSignInModel from '@/models/auth-sign-in.model'
import auth from '@/services/auth.service'
import httpErrorNotification from '@/services/http-error-notification.service'
export default {
  name: 'LoginModal',
  data () {
    return {
      fullscreenLoading: false,
      model: AuthSignInModel.model(),
      rules: AuthSignInModel.rules()
    }
  },
  methods: {
    onSubmit (e) {
      this.$refs.formLogin.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          return auth.authenticate(
            this.model.email,
            this.model.password,
            this.model.rememberMe
          ).then((response) => {
            if (response.status === 200) {
              location.reload()
              this.$router.push({name: 'Home'})
            } else {
              httpErrorNotification(response)
            }
          }).catch((e) => {
            let error = Object.values(e)
            httpErrorNotification(error[2])
          }).finally(() => {
            this.fullscreenLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .title-sign-in {
    text-align: center;
    h1 {
      margin: 0;
      @include font-primary(21px, semibold);
      color: $carbon;
    }
    .btn-facebook {
      display: none;
      margin-top: 40px;
      background-color: #47639E;
      @include font-primary(12px, bold);
      color: white;
      border: none;
      border-radius: 2px;
      width: 100%;
      cursor: pointer;
    }
    .btn-email {
      margin-top: 30px;
      text-align: left;
      border-bottom: 1px solid #E3E6EA;
      padding-bottom: 16px;
      span {
        @include font-primary(12px, semibold);
    }
    }
  }

  .form-sign-in {
    margin-top: 30px;
  }

  .btns-sign-in {
    text-align: center;
    .btn-sign-in {
      width: 100%;
      background-color: $roseHeader;
      color: white;
      border: none;
      border-radius: 2px;
      @include font-primary(12px, bold);
      cursor: pointer;

    }
    .forget-password {
      display: none;
      color: $roseHeader;
      @include font-primary(12px, regular);
      text-decoration: underline;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/auth-sign-in.vue